import React, {useEffect} from 'react'
import {Image, Transformer} from "react-konva";
import useImage from "use-image";

const ImageItem = ({shapeProps, isSelected, onSelect, onChange}) => {
    // const [image] = useImage('assets/images/background/space-splash001.png');
    const [image] = useImage(shapeProps.src, 'anonymous');
    const shapeRef = React.useRef();
    const trRef = React.useRef();

    useEffect(() => {
        if (isSelected && trRef.current) {
            // we need to attach transformer manually
            // @ts-ignore
            trRef.current.nodes([shapeRef.current]);
            // @ts-ignore
            trRef.current.getLayer().batchDraw();
        }
    }, [isSelected]);

    return (
        <>

            {image &&

                <>
                    <Image
                        onClick={onSelect}
                        onTap={onSelect}
                        ref={shapeRef}
                        x={shapeProps.x}
                        y={shapeProps.y}
                        height={shapeProps.height}
                        width={shapeProps.width}
                        image={image}
                        draggable
                        onDragEnd={(e) => {
                            onChange({
                                ...shapeProps,
                                x: e.target.x(),
                                y: e.target.y()
                            });
                        }}
                        onTransformEnd={(e) => {
                            // transformer is changing scale of the node
                            // and NOT its width or height
                            // but in the store we have only width and height
                            // to match the data better we will reset scale on transform end
                            const node = shapeRef.current || undefined;
                            const scaleX = node.scaleX();
                            const scaleY = node.scaleY();

                            // we will reset it back
                            node.scaleX(1);
                            node.scaleY(1);
                            onChange({
                                ...shapeProps,
                                x: node.x(),
                                y: node.y(),
                                // set minimal value
                                width: Math.max(5, node.width() * scaleX),
                                height: Math.max(node.height() * scaleY)
                            });
                        }}
                    />

                    {isSelected && (
                        <Transformer
                            ref={trRef}
                            boundBoxFunc={(oldBox, newBox) => {
                                // limit resize
                                if (newBox.width < 5 || newBox.height < 5) {
                                    return oldBox;
                                }
                                return newBox;
                            }}
                        />
                    )}
                </>

            }

        </>
    )
}

export default ImageItem
